const routes = [
  {
    path: '/',
    name: 'home',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/auth/Login.vue'),
    meta: { notAuthenticated: true },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: 'forgot-password' */ '@/views/auth/ForgotPassword.vue'),
    meta: { notAuthenticated: true },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: 'reset-password' */ '@/views/auth/ResetPassword.vue'),
    meta: { notAuthenticated: true },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: () => import(/* webpackChunkName: 'reset-password' */ '@/views/auth/AccessDenied.vue'),
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: 'clients' */ '@/views/Clients.vue'),
    meta: { auth: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/add',
    name: 'client-add',
    component: () => import(/* webpackChunkName: 'client-edit' */ '@/views/client/ClientEditPage.vue'),
    meta: { auth: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/edit',
    name: 'client-edit',
    component: () => import(/* webpackChunkName: 'client-edit' */ '@/views/client/ClientEditPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId',
    name: 'client-page',
    component: () => import(/* webpackChunkName: 'client-page' */ '@/views/client/ClientPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/things',
    name: 'client-things',
    component: () => import(/* webpackChunkName: 'client-things' */ '@/views/client/ThingsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/things/catalog',
    name: 'client-things-catalog',
    component: () => import(/* webpackChunkName: 'client-things' */ '@/views/client/things/ClientThingsCatalogPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
    children: [{
      path: ':itemId',
      name: 'client-things-catalog-item',
      component: () => import(/* webpackChunkName: 'catalog' */ '@/views/client/things/ClientThingsCatalogItemPage.vue'),
      meta: { auth: true, clients: true, authorities: ['client:read'] },
      props: true,
    }],
  },
  {
    path: '/clients/:clientId/things/add',
    name: 'add-things',
    component: () => import(/* webpackChunkName: 'client-things' */ '@/views/client/AddThingsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/looks',
    name: 'client-looks',
    component: () => import(/* webpackChunkName: 'client-looks' */ '@/views/client/LooksPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/looks/edit',
    name: 'client-looks-edit',
    component: () => import(/* webpackChunkName: 'client-looks-edit' */ '@/views/client/LooksEditPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/files',
    name: 'client-files',
    component: () => import(/* webpackChunkName: 'client-files' */ '@/views/client/FilesPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/subscriptions',
    name: 'client-subscriptions',
    component: () => import(/* webpackChunkName: 'client-subscriptions' */ '@/views/client/SubscriptionsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/services',
    name: 'client-services',
    component: () => import(/* webpackChunkName: 'client-services' */ '@/views/client/ServicesPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/sandbox',
    name: 'client-sandbox',
    component: () => import(/* webpackChunkName: 'client-services' */ '@/views/client/SandboxPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/sandbox/look-editing',
    name: 'client-sandbox-look-editing',
    component: () => import(/* webpackChunkName: 'client-services' */ '@/views/client/SandboxLooksEditPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/sandbox/catalog',
    name: 'sandbox-catalog',
    component: () => import(/* webpackChunkName: 'catalog' */ '@/views/client/SandboxCatalogPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
    children: [{
      path: ':itemId',
      name: 'sandbox-catalog-item',
      component: () => import(/* webpackChunkName: 'catalog' */ '@/views/client/SandboxCatalogItemPage.vue'),
      meta: { auth: true, clients: true, authorities: ['client:read'] },
      props: true,
    }],
  },
  {
    path: '/clients/:clientId/subscriptions/create',
    name: 'subscription-create',
    component: () => import(/* webpackChunkName: 'client-shopping' */ '@/views/SubscriptionCreatePage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/services/:serviceId',
    name: 'services',
    component: () => import(/* webpackChunkName: 'client-services' */ '@/views/services/ServicePage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/looks/ai',
    name: 'ai-looks-from-clients-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksClientThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка образов из гардероба клиента',
        back: 'client-looks',
      },
    },
  },
  {
    path: '/clients/:clientId/things/:thingId/ai/client-things',
    name: 'ai-looks-by-client-thing-from-clients-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksClientThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка образов 1 вещь клиента + образ из гардероба',
        back: 'client-things',
      },
    },
  },
  {
    path: '/clients/:clientId/things/:thingId/ai/catalog-things',
    name: 'ai-looks-by-client-thing-from-catalog-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksCatalogThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка образов 1 вещь клиента + образ из ГК',
        back: 'client-things',
      },
    },
  },
  {
    path: '/clients/:clientId/shopping/:shoppingId/catalog/:itemId/ai/client-things',
    name: 'ai-looks-by-catalog-thing-from-clients-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksClientThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка образов 1 вещь из каталога + гардероб',
        back: 'shopping-catalog-item',
      },
    },
  },
  {
    path: '/clients/:clientId/shopping/:shoppingId/catalog/:itemId/ai/catalog-things',
    name: 'ai-looks-by-catalog-thing-from-catalog-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksCatalogThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка образов 1 вещь из каталога + образ из ГК',
        back: 'shopping-catalog-item',
      },
    },
  },
  {
    path: '/clients/:clientId/things/ai',
    name: 'ai-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка подбора в гардероб клиента ',
        back: 'client-looks',
      },
    },
  },
  {
    path: '/clients/:clientId/catalog-things/ai',
    name: 'ai-thing-catalog-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiThingCatalogThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Подбора вещей в гардероб клиента',
        back: 'client-things',
      },
    },
  },
  {
    path: '/clients/:clientId/looks/:lookId/ai',
    name: 'ai-things-for-look',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Оценка подбора в гардероб клиента ',
        back: 'client-looks',
      },
    },
  },
  {
    path: '/clients/:clientId/sandbox/catalog-add',
    name: 'catalog-add-to-sandbox',
    component: () => import(/* webpackChunkName: 'catalog-add' */ '@/views/catalog/CatalogAddItem.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/shopping/:shoppingId/catalog-add',
    name: 'catalog-add-to-shopping',
    component: () => import(/* webpackChunkName: 'catalog-add' */ '@/views/catalog/CatalogAddItem.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/compilations',
    name: 'client-compilations',
    component: () => import(/* webpackChunkName: 'client-compilations' */ '@/views/client/CompilationsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/compilations/:compilationId/',
    name: 'compilation-root',
    component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationRootPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
    redirect: { name: 'compilation-overview' },
    children: [
      {
        path: 'overview',
        name: 'compilation-overview',
        component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationOverviewPage.vue'),
        meta: { auth: true, clients: true, authorities: ['client:read'] },
      },
      {
        path: 'things',
        name: 'compilation-things',
        component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationThingsPage.vue'),
        meta: { auth: true, clients: true, authorities: ['client:read'] },
      },
    ],
  },
  {
    path: '/clients/:clientId/compilations/:compilationId/things/:thingId',
    name: 'compilation-edit-thing',
    component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationEditThingPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/compilations/:compilationId/looks-edit',
    name: 'compilations-looks-edit',
    component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationLooksEditPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/compilations/:compilationId/things-add',
    name: 'compilation-add-things',
    component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationAddThingsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/clients/:clientId/compilations/:compilationId/looks/ai',
    name: 'compilation-ai-looks-from-clients-things',
    component: () => import(/* webpackChunkName: 'ai' */ '@/views/client/AiLooksClientThingsPage.vue'),
    meta: {
      auth: true,
      clients: true,
      authorities: ['client:read'],
      options: {
        title: 'Добавить ai образ из вещей клиента',
        back: 'client-looks',
      },
    },
  },
  {
    path: '/compilations',
    name: 'compilations',
    component: () => import(/* webpackChunkName: 'compilations' */ '@/views/compilations/CompilationsPage.vue'),
    meta: { auth: true, clients: true, authorities: ['client:read'] },
  },
  {
    path: '/catalog-add',
    name: 'catalog-add-item',
    component: () => import(/* webpackChunkName: 'catalog-add' */ '@/views/catalog/CatalogAddItem.vue'),
    meta: { auth: true },
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: () => import(/* webpackChunkName: 'catalog' */ '@/views/catalog/CatalogPage.vue'),
    meta: { auth: true },
    children: [{
      path: ':itemId',
      name: 'catalog-item',
      component: () => import(/* webpackChunkName: 'catalog' */ '@/views/catalog/CatalogItemPage.vue'),
      meta: { auth: true },
      props: true,
    }],
  },
  {
    path: '/background-clipping',
    name: 'background-clipping',
    component: () => import(/* webpackChunkName: 'background-clipping' */ '@/views/BackgroundClipping.vue'),
    meta: { auth: true },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: 'users' */ '@/views/users/Users.vue'),
    meta: { auth: true, authorities: ['user:read', 'user:write'] },
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import(/* webpackChunkName: 'roles' */ '@/views/roles/Roles.vue'),
    meta: { auth: true, authorities: ['security:read', 'security:write'] },
  },
  {
    path: '/supplier-things',
    name: 'supplier-things',
    component: () => import(/* webpackChunkName: 'suppliers' */ '@/views/suppliers/SupplierThingsPage.vue'),
    meta: { auth: true, authorities: ['supplier:operate'] },
  },
  {
    path: '/purchasing',
    name: 'purchasing',
    component: () => import(/* webpackChunkName: 'purchasing' */ '@/views/purchasing/PurchasingPage.vue'),
    meta: { auth: true, authorities: ['supplier:operate'] },
  },
  {
    path: '/promo-cards',
    name: 'promo-cards',
    component: () => import(/* webpackChunkName: 'promo-cards' */ '@/views/promo-cards/PromoCardsPage.vue'),
    meta: { auth: true, authorities: ['marketing:read'] },
  },
  {
    path: '/promo-card/:id',
    name: 'promo-card-edit',
    component: () => import(/* webpackChunkName: 'promo-cards' */ '@/views/promo-cards/PromoCardEditPage.vue'),
    meta: { auth: true, authorities: ['marketing:read'] },
  },
  {
    path: '/promo-cards/stories/:id',
    name: 'story-edit',
    component: () => import(/* webpackChunkName: 'promo-cards' */ '@/views/promo-cards/StoryPage.vue'),
    meta: { auth: true, authorities: ['marketing:read'] },
  },
  {
    path: '/promo-cards/stories/add',
    name: 'story-add',
    component: () => import(/* webpackChunkName: 'promo-cards' */ '@/views/promo-cards/StoryPage.vue'),
    meta: { auth: true, authorities: ['marketing:read'] },
  },
];

export default routes;
